export default __webpack_public_path__ + "static/media/logo-bcsp.3ce84dae.png";